module.exports = __webpack_public_path__ + "static/apartment_350-218a934cf21ee93fb35d0cf4f7289c8e.webp";